export const TIMERS = {
  ONE_SECOND: 1000,
  LAST_ACTIVE: 900000,
  LOCAL_STORAGE_SAVE: 2592000000,
};
